

























































































































































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { GapTransportationCoordinationReportFilter } from "@/store/modules/types";
import StatusFilter from "@/components/report/filters/Status2.vue";
import SubStatusFilter from "@/components/report/filters/SubStatus2.vue";
import InsurerFilter from "@/components/report/filters/Insurers2.vue";
import ReferenceDateFilter from "@/components/report/filters/ReferenceDate2.vue";
import ApptDateFilter from "@/components/report/filters/ApptDate2.vue";
import AdmissionDischargeFilter from "@/components/report/filters/AdmissionDischarge2.vue";
import PriorityFilter from "@/components/report/filters/ApptPriorities.vue";

@Component({
  components: {
    StatusFilter,
    SubStatusFilter,
    InsurerFilter,
    ReferenceDateFilter,
    ApptDateFilter,
    AdmissionDischargeFilter,
    PriorityFilter
  },
  computed: mapState("gaps", ["insurers", "campaigns",]),
})
export default class TransportationCoordinationSearch extends Vue {
  @Model("change") readonly filter!: GapTransportationCoordinationReportFilter;
  lastShownFilter!: string;
  showInsurerFilter = false;
  showStatusFilter = false;
  showSubStatusFilter = false;
  showReferenceDateFilter = false;
  showApptDateFilter = false;
  showAdmisionDischargeFilter = false;
  showPriorityFilter = false;

  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter);
    }
    let show = false;
    switch (filter) {
      case "INSURER":
        show = !this.showInsurerFilter;
        this.showInsurerFilter = show;
        break;
      case "STATUS":
        show = !this.showStatusFilter;
        this.showStatusFilter = show;
        break;
      case "SUB-STATUS":
        show = !this.showSubStatusFilter;
        this.showSubStatusFilter = show;
        break;
      case "REFERENCE_DATE":
        show = !this.showReferenceDateFilter;
        this.showReferenceDateFilter = show;
        break;
      case "APPT_DATE":
        show = !this.showApptDateFilter;
        this.showApptDateFilter = show;
        break;
      case "ADMISSION_DISCHARGE":
        show = !this.showAdmisionDischargeFilter;
        this.showAdmisionDischargeFilter = show;
        break;
      case "PRIORITY":
        show = !this.showPriorityFilter;
        this.showPriorityFilter = show;
        break;
    }
    this.lastShownFilter = show ? filter : "";
  }
}
